import { render } from "./esco-configuracao-empresa.vue?vue&type=template&id=45bf2a72&scoped=true"
import script from "./esco-configuracao-empresa.vue?vue&type=script&lang=js"
export * from "./esco-configuracao-empresa.vue?vue&type=script&lang=js"

import "./esco-configuracao-empresa.vue?vue&type=style&index=0&id=45bf2a72&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45bf2a72"]])

export default __exports__